import { SwalAlert } from "../../components";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  useDropdown,
  UsejobDropdowns,
  UsecitiesDropdowns,
  useStatesDropdowns,
} from "../../actions/authActions";
export default () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loadingToapi, setLoadingToapi] = useState(false);
  const [selectedOption, setSelectedOption] = useState({
    freelance: false,
    salary: true,
    active: 1,
    featured: false,
  });

  const [select, setSelect] = useState({
    country: "",
    states: "",
    city: "",
    salary_period: "",
    job_shift: "",
    job_type: "",
    gender: "",
    degree_level: "",
    job_experience: "",
  });
  const userData = useSelector((state) => state.app.userData.userData);
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      jobtitle: "",
      expirydate: "",
      postCode: "",
      salaryFrom: "",
      salaryTo: "",
      positions: "",
      description: "",
      benefits: "",
    },
  });
  const baseURL = process.env.REACT_APP_BASE_URL;
  const mutation = useMutation({
    mutationFn: async (createJobData) => {
      const accessToken = localStorage.getItem("accessToken");
      const { data } = await axios.post(
        `${baseURL}/api/v2/job`,
        createJobData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      return data;
    },
    onSuccess: (data) => {
      dispatch({
        type: "UPDATE_CREATE_JOB_DATA",
        payload: { createJobData: data },
      });
      SwalAlert(data?.status, data?.message, "success");
      setLoadingToapi(false);
      navigate("/empjob-listing");
    },
    onError: (error) => {
      const responseData = error.response?.data?.errors;
      const message = responseData
        ? Object.entries(responseData)
            .map(([key, value]) => `${key}: ${value.join(", ")}`)
            .join("\n")
        : "An unexpected error occurred.";

      setLoadingToapi(false);
      SwalAlert("Oops...", message, "error");
    },
  });

  const { data: jobDropdowns, isLoading } = UsejobDropdowns();
  const { data: dropdowns, isLoading: dropdownLoading } = useDropdown();
  const { data: states, isLoading: statesisLoading } = useStatesDropdowns(
    select?.country
  );
  const { data: cities, isLoading: citiesisLoading } = UsecitiesDropdowns(
    select?.states
  );

  const handleDropdwonSelect = (name, value) => {
    setSelect((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSelectOptions = (e, id) => {
    const isChecked = e.target.checked;

    setSelectedOption((prev) => {
      const updated = { ...prev };

      if (id === "active") {
        updated.active = isChecked ? 1 : null;
      } else if (id === "inactive") {
        updated.active = isChecked ? 0 : null;
      } else {
        updated[id] = isChecked;
      }

      return updated;
    });
  };

  const onSubmit = (data, e) => {
    e.preventDefault();
    setLoadingToapi(true);
    const createJobData = {
      company_id: userData?.employer?.id,
      title: data.jobtitle,
      job_type_id: select?.job_type,
      description: data?.description,
      benefits: data?.benefits,
      salary_from: data.salaryFrom,
      salary_to: data.salaryTo,
      country_id: select?.country,
      state_id: select?.states,
      city_id: select?.city,
      salary_period_id: select?.salary_period,
      job_shift_id: select?.job_shift,
      gender_id: select?.gender,
      expiry_date: data.expirydate,
      num_of_positions: data.positions,
      degree_level_id: select?.degree_level,
      job_experience_id: select?.job_experience,
      postal_code: data.postCode,
      is_featured: selectedOption?.featured ? 1 : 0,
      is_active: selectedOption?.active,
      hide_salary: selectedOption?.salary ? 0 : 1,
      is_freelance: selectedOption?.freelance ? 1 : 0,
    };
    mutation.mutate(createJobData);
  };
  const options = [
    { id: "freelance", label: "Freelance" },
    { id: "salary", label: "Show Salary" },
    { id: "active", label: "Active" },
    { id: "inactive", label: "Inactive" },
    { id: "featured", label: "Featured" },
  ];

  return {
    loadingToapi,
    register,
    handleSubmit,
    setValue,
    getValues,
    control,
    errors,
    jobDropdowns,
    isLoading,
    dropdowns,
    dropdownLoading,
    states,
    statesisLoading,
    cities,
    citiesisLoading,
    selectedOption,
    handleSelectOptions,
    handleDropdwonSelect,
    onSubmit,
    options,
    select,
  };
};
